export const REQUEST_COMPANY_LOOKUP = 'page/REQUEST_COMPANY_LOOKUP';
export const REQUEST_COMPANY_LOOKUP_LOADING = `${REQUEST_COMPANY_LOOKUP} [loading]`;
export const REQUEST_COMPANY_LOOKUP_COMPLETED = `${REQUEST_COMPANY_LOOKUP} [completed]`;

export const SUBMIT_COMPANY_DETAILS = 'page/SUBMIT_COMPANY_DETAILS';
export const SUBMIT_COMPANY_DETAILS_LOADING = `${SUBMIT_COMPANY_DETAILS} [loading]`;
export const SUBMIT_COMPANY_DETAILS_COMPLETED = `${SUBMIT_COMPANY_DETAILS} [completed]`;

export const TOGGLE_MANUAL_COMPANY_STATE = 'page/TOGGLE_MANUAL_COMPANY_STATE';
